// extracted by mini-css-extract-plugin
export default {"search-box":"bb_QF","search-box__input":"bb_QG form-control","search-box__icon":"bb_QH ml-2"};